export default function mapStateToProps(data, storeName) {
  var _ref;

  if (storeName === void 0) {
    storeName = 'lightProps';
  }

  return _ref = {}, _ref[storeName] = data, _ref;
}